import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function ApiAndSchemaEvolution() {
    return (
        <TopicLayout
            title="API & schema evolution"
            intro="Changing a contract that other services or clients already depend on, without breaking them. Additive, backward-compatible changes ship continuously; breaking changes need a deliberate migration path."
            diagram={
                <Diagram viewBox="0 0 560 170">
                    <text x={280} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Expand–contract: never break a client in one deploy</text>
                    <Box x={30} y={50} width={140} height={50} label="Expand" sublabel="add new, keep old"/>
                    <Box x={210} y={50} width={140} height={50} label="Migrate" sublabel="clients switch over" accent/>
                    <Box x={390} y={50} width={140} height={50} label="Contract" sublabel="remove the old field"/>
                    <Arrow x1={170} y1={75} x2={210} y2={75}/>
                    <Arrow x1={350} y1={75} x2={390} y2={75}/>
                    <text x={100} y={135} textAnchor="middle" fontSize={11} opacity={0.7}>old ✓ new ✓</text>
                    <text x={280} y={135} textAnchor="middle" fontSize={11} opacity={0.7}>readers move to new</text>
                    <text x={460} y={135} textAnchor="middle" fontSize={11} opacity={0.7}>new only</text>
                </Diagram>
            }
            useWhen={[
                'A field, endpoint or message format is consumed by clients or services that cannot all be deployed at the same moment as the change.',
                'A genuinely breaking change is unavoidable, such as changing a field\'s type or removing something still in use.'
            ]}
            tradeOff="Additive, backward-compatible changes — new optional fields, new endpoints, new enum values a client can ignore — ship without coordination and are almost always worth the small ongoing cost of a slightly looser schema. True breaking changes need either a version bump maintained in parallel, or an expand-contract migration: add the new shape alongside the old, move every consumer over, confirm nothing still uses the old shape, then remove it. Skipping the confirmation step is the most common cause of an outage from a 'safe' cleanup."
            ruleOfThumb="Prefer additive, backward-compatible changes by default; when a breaking change is unavoidable, use expand-contract and verify old-field usage has actually dropped to zero before removing anything."
        />
    )
}
